import myHealthIcon from "../assets/icons/my-health.svg";

import collaborationIcon from "../assets/images/onboarding/collaboration.svg";
import communicationIcon from "../assets/images/onboarding/communication.svg";
import engagementIcon from "../assets/images/onboarding/engagement.svg";
import adaptabilityIcon from "../assets/images/onboarding/adaptability.svg";

export const generateRandomScore = () => Math.random();

export const getDashboardData = (userHealth, teamHealth = null, leadershipHealth = null) => ({
  my_health: {
    icon: myHealthIcon,
    title: I18n.t("dashboard.my_health.title"),
    updateLink: teamHealth ? null : "/onboardings/new",
    kpis: [
      {
        title: I18n.t("dashboard.my_health.adaptability.title"),
        score: userHealth ? userHealth.adaptability?.score : 0,
        indicator: userHealth?.adaptability?.indicator,
        message: userHealth?.adaptability?.message,
        icon: adaptabilityIcon,
        about: I18n.t("dashboard.my_health.adaptability.about")
      },
      {
        title: I18n.t("dashboard.my_health.collaboration.title"),
        score: userHealth ? userHealth.collaboration?.score : 0,
        indicator: userHealth?.collaboration?.indicator,
        message: userHealth?.collaboration?.message,
        icon: collaborationIcon,
        about: I18n.t("dashboard.my_health.collaboration.about")
      },
      {
        title: I18n.t("dashboard.my_health.communication.title"),
        score: userHealth ? userHealth.communication?.score : 0,
        indicator: userHealth?.communication?.indicator,
        message: userHealth?.communication?.message,
        icon: communicationIcon,
        about: I18n.t("dashboard.my_health.communication.about")
      },
      {
        title: I18n.t("dashboard.my_health.engagement.title"),
        score: userHealth ? userHealth.engagement?.score : 0,
        indicator: userHealth?.engagement?.indicator,
        message: userHealth?.engagement?.message,
        icon: engagementIcon,
        about: I18n.t("dashboard.my_health.engagement.about")
      }
    ]
  },
});